import update from 'immutability-helper';
import _ from 'lodash';

import { MODAL_MESSAGE_NAMES } from '../../../components/common/modal-message/modal-message.actions';
import { NOTIFICATION_PLACEMENT } from '../../../components/common/notifications/notifications.constants';
import { NotificationTheme } from '../../../constants/notification';
import { NAMES as NOTIFICATION_ACTIONS } from '../../actions/notifications';

const formatNotification = (notification) => ({
  theme: NotificationTheme.Standard,
  ...notification,
  id: _.uniqueId('notification_'),
});

const getIndex = (notifications, id) => _.findIndex(notifications, { id });

export const notifications = (state = [], { type, payload }) => {
  switch (type) {
    case NOTIFICATION_ACTIONS.ADD_NOTIFICATION: {
      return [...state, formatNotification(payload)];
    }

    case NOTIFICATION_ACTIONS.ADD_NOTIFICATIONS:
      return [...state, ..._.map(payload, formatNotification)];

    case NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION:
      return _.reject(state, { id: payload.id });

    case NOTIFICATION_ACTIONS.SHOW_NOTIFICATION:
      return update<any, any>(state, {
        [getIndex(state, payload.id)]: { show: { $set: true } },
      });

    case MODAL_MESSAGE_NAMES.CLOSED: {
      return _.filter(
        state,
        (notification: any) =>
          notification.placement !== NOTIFICATION_PLACEMENT.MODAL,
      );
    }

    default: {
      return state;
    }
  }
};
